import { Duplexer } from '@wix/duplexer-js';


let duplexerInstance: Duplexer;

export const useDuplexerChatbotInstance = () => {
  if (!duplexerInstance) {

    duplexerInstance = new Duplexer('duplexer.wix.com', {
      instanceUpdater: {
        getInstance: () => '',
      },
    });
  }

  return duplexerInstance;
};
